export const borderRadius = {
  '2xs': '0.4rem',
  xs: '0.8rem',
  sm: '1.2rem',
  lg: '10rem',
  full: '100%',
};
